const getters = {
  theme:state=>state.settings.theme,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  permission: state =>state.permission.permissionList,
  hasPermission: state =>(id)=> {
    return  state.permission.permissionList.find((item)=> item==id)!=undefined
  },
  isShowColumn: state =>(table,field)=> {
    let columnConfig = state.column[table];
    if(!columnConfig){
      return  true;
    }
  let find=  columnConfig.find((item)=>{
      return item.field===field
    })
    if(!find){
      return true;
    }
    return  find.show!==false
  },

}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js